import { Label, LoadingSpinner, Typography } from '@neo4j-ndl/react';
import type { DbmsInfo } from '@nx/state/desktop';
import cx from 'classnames';

import { getOnlineStatusColor } from '../entities/helpers';
import { useToggleInstanceRunStatus } from '../hooks/use-toggle-instance-run-status';

export const InstanceStatusLabelLoading = ({ label }: { label?: string }) => {
  if (label === undefined) {
    return null;
  }

  return (
    <span role="status" className="flex h-6 flex-row items-center gap-1 uppercase tracking-normal">
      <LoadingSpinner aria-label={`Instance is ${label}`} />
      <Typography variant="body-medium">{label}</Typography>
    </span>
  );
};

export const InstanceStatusLabel = ({ instance }: { instance: DbmsInfo }) => {
  const { isStopped, isStarted, isStarting, isStopping } = useToggleInstanceRunStatus(instance);

  let label;

  if (isStarted) {
    label = 'Running';
  }

  if (isStopped) {
    label = 'Stopped';
  }

  if (isStarting) {
    label = 'Starting';
  }

  if (isStopping) {
    label = 'Stopping';
  }

  if (isStopping || isStarting) {
    return <InstanceStatusLabelLoading label={label} />;
  }

  return (
    <Label
      fill="clean"
      hasIcon
      color={getOnlineStatusColor(instance)}
      className={cx('truncate font-normal uppercase [&_.ndl-icon-svg]:shrink-0', {
        '[&_.ndl-label-text]:!text-success-text': isStarted,
        '[&_.ndl-label-text]:!text-neutral-text-weaker': isStopped,
      })}
    >
      {label}
    </Label>
  );
};
